import {
	BaseAPIResponse,
	CampusCancelInterviewRoundInput,
	CampusScheduleInterviewRoundInput,
	GetCampusHiringApplicationsWithCandidatesAPIResponse,
	GetCampusHiringCandidatesAPIResponse,
	GetHiringApplicationsGraphDataAPIResponse,
	ShortlistCampusHiringCandidateAPIResponse,
	UserFiltersForApis,
} from 'types';
import { baseApi } from './axios';
import { API_ENDPOINT } from 'src/config/env.config';

const baseUrl = `${API_ENDPOINT}/campusHiring`;

export const getCampusHiringCandidates = async (
	data: UserFiltersForApis & {
		page?: number;
		limit?: number;
	},
): Promise<GetCampusHiringCandidatesAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/candidates`, data);
	return response.data;
};

export const shortlistCampusHiringCandidate = async ({
	candidateId,
}: {
	candidateId: string;
}): Promise<ShortlistCampusHiringCandidateAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/shortlist-candidate`, { candidateId });
	return response.data;
};

export const getCampusHiringApplicationsWithCandidates = async (
	data: UserFiltersForApis & {
		page?: number;
		limit?: number;
		search?: string;
		hiringAssessment?: string;
	},
): Promise<GetCampusHiringApplicationsWithCandidatesAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/applications`, data);
	return response.data;
};

export const campusScheduleInterviewRoundForApplication = async (
	payload: CampusScheduleInterviewRoundInput,
): Promise<BaseAPIResponse> => {
	const response = await baseApi.patch(`${baseUrl}/schedule-interview-round`, payload);
	return response.data;
};

export const campusRescheduleInterviewRoundForApplication = async (
	payload: CampusScheduleInterviewRoundInput,
): Promise<BaseAPIResponse> => {
	const response = await baseApi.patch(`${baseUrl}/reschedule-interview`, payload);
	return response.data;
};

export const campusCancelInterviewRoundForApplication = async (
	payload: CampusCancelInterviewRoundInput,
): Promise<BaseAPIResponse> => {
	const response = await baseApi.patch(`${baseUrl}/cancel-interview-round`, payload);
	return response.data;
};

export const hireAssessmentCandidate = async ({
	candidateIds,
}: {
	candidateIds: string[];
}): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/hire-candidates`, { candidateIds });
	return response.data;
};

export const rejectAssessmentCandidate = async ({
	candidateIds,
}: {
	candidateIds: string[];
}): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/reject-candidates`, { candidateIds });
	return response.data;
};

export const getHiringApplicationsGraphData = async (
	data: {
		page: number;
		sort?: string;
		limit?: number;
		hiringAssessment?: string;
	},
): Promise<GetHiringApplicationsGraphDataAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/get-applications-graph-data`, data);
	return response.data;
};
